module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("default"), _vm._v(_vm._s(_vm.showNum) + "\n")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-105a7c50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/numAnimate.vue
// module id = 231
// module chunks = 2